import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmModalData } from '../../models';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
    @Input() data: ConfirmModalData = { title: '', content: '' };
    @Output() closed = new EventEmitter<boolean>();

    close(bool: boolean): void {
        this.closed.emit(bool);
    }
}
